module.exports = __webpack_public_path__ + "static/img/qmwallet2-footer-help.9063788f.png";